@if (iShowConsumptions) {
  <div>
    <table class="table consumption-table">
      <thead>
        <tr>
          @if (!iNavMobile) {
            <th scope="col" class="consumption-col-id">#</th>
          }
          <th scope="col" class="consumption-col-date">Date</th>
          <th scope="col">Article</th>
          <th scope="col" class="consumption-col-price">Prix</th>
          <th scope="col" class="consumption-col-qty">Quantité</th>
          <th scope="col" class="consumption-col-total">Montant</th>
          @if (!iNavMobile && !iIsOneStudent) {
            <th scope="col">Elève</th>
          }
          @if (!iNavMobile && !iIsStudent) {
            <th scope="col" class="consumption-col-description">Description</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (c of iConsumptions; track c) {
          <tr>
            @if (!iNavMobile) {
              <th class="consumption-col-id" scope="row">{{ c.id }}</th>
            }
            <td class="consumption-col-date">{{ c.date | date:'dd/MM/yyyy' }}</td>
            <td>{{ c.article.name }}</td>
            <td class="consumption-col-price">{{ c.article.price }} €</td>
            <td class="consumption-col-qty">{{ c.quantity }}</td>
            <td class="consumption-col-total">{{ c.cost }} €</td>
            @if (!iNavMobile && !iIsOneStudent) {
              <td>{{ c.studentName }}</td>
            }
            @if (!iNavMobile && !iIsStudent) {
              <td class="consumption-col-description">{{ c.description }}</td>
            }
          </tr>
        }
      </tbody>
    </table>
    @if (iPageConsumption) {
      <app-pagination [iEmpty]="iPageConsumption.empty" [iFirst]="iPageConsumption.first"
        [iLast]="iPageConsumption.last" [iNumber]="iPageConsumption.number" [iTotalPages]="iPageConsumption.totalPages"
        [iPageSize]="iPageConsumption.size"
        (currentPageChanged)="onChangeConsumptionPage($event)">
      </app-pagination>
    }
  </div>
}
